import {
  FORM_ADMINISTRATION_DATA_REQUEST,
  FORM_ADMINISTRATION_DATA_SUCCESS,
  FORM_ADMINISTRATION_DATA_FAIL,
} from '../constants/formAdministrationConstants';

export const formAdministrationReducer = (state = { formData: [] }, action) => {
  switch (action.type) {
    case FORM_ADMINISTRATION_DATA_REQUEST:
      return { loading: true, formData: [] };
    case FORM_ADMINISTRATION_DATA_SUCCESS:
      return { loading: false, formData: action.payload };
    case FORM_ADMINISTRATION_DATA_FAIL:
      return { loading: false, error: action.payload };
    default:
      return state;
  }
};
